export const FALLBACK_URL = 'https://www.atlassian.com/';

export const getSmartCardFallbackUrl = () => {
	if (typeof window === 'undefined' || !window.location?.href) {
		return FALLBACK_URL;
	}

	return window.location.href;
};
